import { EditorController } from '@ibiz-template/runtime';
import { IRating } from '@ibiz/model-core';

/**
 * 评分器编辑器控制器
 *
 * @export
 * @class RateEditorController
 * @extends {EditorController}
 */
export class RateEditorController extends EditorController<IRating> {}
